<form [formGroup]="carSearchForm">
  <div class="tab-content">
    <div class="tab-pane fade active show" id="Cars">
      <div class="d-flex align-items-center justify-content-between flex-wrap mb-2">
        <div class="d-flex align-items-center flex-wrap">
          <div class="form-check d-flex align-items-center me-3 mb-2">
             <input
                class="form-check-input mt-0"
                type="radio"
                id="sameDropOff"
                formControlName="carRentalType"
                [value]="carRentalTypeEnum.SAME_DROP"
                [checked]="carSearchForm.value.carRentalType === carRentalTypeEnum.SAME_DROP"
              />
              <label class="form-check-label fs-14 ms-2" for="sameDropOff">
                Same drop-off
              </label>
          </div>
          <div class="form-check d-flex align-items-center me-3 mb-2">
             <input
                class="form-check-input mt-0"
                type="radio"
                id="diffDropOff"
                formControlName="carRentalType"
                [value]="carRentalTypeEnum.DIFFERENT_DROP"
                [checked]="carSearchForm.value.carRentalType === carRentalTypeEnum.DIFFERENT_DROP"
              />
              <label class="form-check-label fs-14 ms-2" for="diffDropOff">
                Different drop-off
              </label>
          </div>
        </div>
      </div>
      <div class="d-lg-flex">
        <div class="d-flex  form-info">
          <div class="form-item dropdown from-location">
              <app-location-picker
                label="From"
                formControlName="pickup_id"
                keyToPatch="id"
                [searchType]="searchTypeEnum.CAR"
              ></app-location-picker>

          </div>

          <div class="form-item dropdown to-location ps-2 ps-sm-3" *ngIf="carSearchForm.value.carRentalType === carRentalTypeEnum.DIFFERENT_DROP">
            <app-location-picker label="To" formControlName="dropoff_id" keyToPatch="id" [searchType]="searchTypeEnum.CAR">
              <span class="way-icon badge badge-primary rounded-pill translate-middle" location-picker-icon>
                    <i class="fa-solid fa-arrow-right-arrow-left"></i>
              </span>
            </app-location-picker>
          </div>

          <!-- Date & Time Picker Container: All Side by Side -->
          <!-- Date Pickers Row -->
          <div class="date-picker-container" style="position: relative;">
            <!-- Hidden Date Range Picker -->
            <input type="text"
              style="position: absolute; top: 0; left: 0; width: 1px; height: 1px; opacity: 0; pointer-events: none;"
              bsDaterangepicker
              #dateRangePicker="bsDaterangepicker"
              [bsConfig]="{
                adaptivePosition: true,
                containerClass: 'theme-default',
                minDate: bsValue,
                dateInputFormat: 'DD-MM-YYYY',
                rangeSeparator: ' - ',
                showWeekNumbers: false,
                selectFromOtherMonth: true
              }"
              (bsValueChange)="onDateRangeChange($event)" />

            <div class="form-item position-relative">
              <label class="form-label fs-14 text-default mb-1" for="pickup-date-input">Departure</label>
              <input id="pickup-date-input" type="text" class="form-control datetimepicker"
                readonly
                [value]="getFormattedDate('pickup_date')"
                (click)="openDateRangePicker($event)"
                placeholder="Select departure date" />
              <i class="fa-regular fa-calendar-days" aria-hidden="true" style="position: absolute; right: 0px; top: 38px; color: #6c757d;"></i>
              <p class="fs-12 mb-0">{{ getDateLabel('pickup_date') }}</p>
            </div>

            <div class="form-item position-relative">
              <label class="form-label fs-14 text-default mb-1" for="dropoff-date-input">Return</label>
              <input id="dropoff-date-input" type="text" class="form-control datetimepicker"
                readonly
                [value]="getFormattedDate('dropoff_date')"
                (click)="openDateRangePicker($event)"
                placeholder="Select return date" />
              <i class="fa-regular fa-calendar-days" aria-hidden="true" style="position: absolute; right: 0px; top: 38px; color: #6c757d;"></i>
              <p class="fs-12 mb-0">{{ getDateLabel('dropoff_date') }}</p>
            </div>
          </div>

          <!-- Time Pickers Row: Below Date Pickers -->
          <div class="time-picker-container d-flex gap-2 align-items-stretch mt-2">
            <div class="form-item position-relative">
              <span class="form-label fs-14 text-default mb-1">Pickup Time</span>
              <p-calendar inputId="calendar-timeonly" formControlName="pickup_time" name="time" [timeOnly]="true" [hourFormat]="'24'"
                [placeholder]="timeStr">
              </p-calendar>
              <i class="fa-solid fa-chevron-down" aria-hidden="true" style="position: absolute; right: 12px; bottom: 12px; color: #6c757d;"></i>
            </div>

            <div class="form-item position-relative">
              <span class="form-label fs-14 text-default mb-1">Dropoff Time</span>
              <p-calendar inputId="calendar-timeonly" formControlName="dropoff_time" name="time" [timeOnly]="true" [hourFormat]="'24'"
                [placeholder]="timeStr">
              </p-calendar>
              <i class="fa-solid fa-chevron-down" aria-hidden="true" style="position: absolute; right: 12px; bottom: 12px; color: #6c757d;"></i>
            </div>
          </div>

    <div class="form-item dropdown" >
        <div data-bs-toggle="dropdown" data-bs-auto-close="outside" role="menu">
          <span class="form-label fs-14 text-default mb-1">Driver's Age</span>
              <h5>{{ carSearchForm.get('driver_age')?.value }} <span class="fw-normal fs-14">Year's Old</span></h5>
              <p class="fs-12 mb-0"><span class="fw-bold fs-14">Issued Country</span> {{ carSearchForm.get('country_res')?.value }}</p>
            </div>
            <div class="dropdown-menu dropdown-menu-end dropdown-xl">
              <h5 class="mb-3">Add Driver's age and Licence Details</h5>
              <div class="mb-3 border br-10 info-item pb-1">
                <div class="row" >
                  <div class="col-md-12">
                    <div class="mb-3 d-flex align-items-center justify-content-between">
            <span class="form-label text-gray-9 mb-2">Age</span>
                      <app-common-counter [MIN]="18" [MAX]="100" formControlName="driver_age" />
                    </div>
                  </div>

                  <div class="col-md-12">
                    <div class="mb-3 d-flex align-items-center justify-content-between">
            <span class="form-label text-gray-9 mb-2">Licence Issued Country</span>
                       <app-select
                          [label]="''"
                          formControlName="country_res"
                          [options]="(countries$ | async) || []"
                          [placeholder]="'Select Country'"
                        ></app-select>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
        <button (click)="onSearch()" class="btn btn-primary search-btn rounded d-flex align-items-center justify-content-center" [disabled]="carSearchForm.invalid || isLoading">
          <output *ngIf="isLoading" class="spinner-border spinner-border-sm me-2" aria-live="polite"></output>
          <span *ngIf="!isLoading">Search</span>
          <span *ngIf="isLoading">Loading...</span>
        </button>
      </div>
    </div>
  </div>
</form>
